import { render, staticRenderFns } from "./new-cart-addresses.vue?vue&type=template&id=055cd3ca&"
import script from "./new-cart-addresses.vue?vue&type=script&lang=js&"
export * from "./new-cart-addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports